import {FC, ReactNode} from 'react';
//mui
import {Box, InputAdornment, SxProps, Theme, Typography, useMediaQuery} from '@mui/material';
//icons
import {ReactComponent as SearchIcon} from '@icons/search-normal.svg';
//constants
import {BODY1, defaultPageSize, SEARCH, START} from '@/utils/constants';
//types
import {IFilterGroup} from '@/utils/types';
//components
import Input from '../../Inputs/Input';
import FilterMenu from '../FilterMenu';
import TeamFilterContent from '../FilterMenu/FilterContent';
//styles
import {searchHeaderStyle} from './SearchHeader.styles';
import { TABLES_ENTITIES } from '@/utils/enums';

interface SearchHeaderProps {
	value?: string;
	page: number;
	items: number;
	total?: number;
	disabled?: boolean;
	searchPlaceholder?: string;
	actionButton?: ReactNode;
	filterOption?: IFilterGroup[];
	parentClassName?: SxProps<Theme>;
	onPressEnter: () => void;
	onSearchChange?: (value: string) => void;
	onFilterChange?: (groupTitle: string, optionTitle: string, id?: number) => void;
	isMobileMode?: boolean;
	onOpenDropdown?: () => void;
	unitName?: TABLES_ENTITIES;
}

const SearchHeader: FC<SearchHeaderProps> = ({
	value,
	page,
	items,
	total = 0,
	disabled,
	actionButton,
	filterOption,
	searchPlaceholder = SEARCH,
	parentClassName,
	onSearchChange,
	onPressEnter,
	onFilterChange,
	isMobileMode,
	onOpenDropdown,
	unitName = TABLES_ENTITIES.ITEMS,
}) => {
	// const itemsAmount = `Showing ${page}—${items} of ${total} ${unitName}`;
	// const totalItems = `Showing ${total} ${unitName}`;

	const isTablet = useMediaQuery('(min-width:640px) and (max-width:1199.98px)');
	const isDesktop = useMediaQuery('(min-width:1200px)');


	const startItem = page * defaultPageSize - defaultPageSize + 1;
    const endItem = Math.min(page * defaultPageSize, total);

    const showingText = !items
        ? `Showing 0 ${unitName}`
        : isDesktop
        ? `Showing ${startItem}—${endItem} of ${total} ${unitName}`
        : `Showing ${total} ${unitName}`;


	return (
		<Box sx={{...searchHeaderStyle.wrapper, padding: 0, ...parentClassName}}>
			{(isTablet || isDesktop) && (
				<Typography variant={BODY1} sx={searchHeaderStyle.title}>
					{/* {isTablet ? totalItems : itemsAmount} */}
					{showingText}
				</Typography>
			)}

			<Box sx={searchHeaderStyle.actions}>
				{onFilterChange && filterOption && (
					<FilterMenu
						content={<TeamFilterContent options={filterOption} onFilterChange={onFilterChange} />}
						isCloseBackdrop
						isMobileMode={isMobileMode}
						onOpenDropdown={onOpenDropdown}
					/>
				)}

				{onSearchChange && (
					<Input
						value={value}
						handlePressEnter={onPressEnter}
						sx={searchHeaderStyle.search}
						onChange={onSearchChange}
						placeholder={searchPlaceholder}
						disabled={disabled}
						InputProps={{
							startAdornment: (
								<InputAdornment position={START}>
									<SearchIcon />
								</InputAdornment>
							),
						}}
					/>
				)}

				{actionButton && actionButton}
			</Box>
		</Box>
	);
};
export default SearchHeader;
